import { getLabelForDatapoint } from 'pages/insights-pro/graphs/graphUtils';
import { Model } from 'pages/Benchmarking/performance/model';
import { DataEntry, DataResult } from 'models/data';
import { Measure } from 'services/model/model.service';
import { IntlShape } from 'react-intl';
import { BenchmarkingTemporalType } from 'components/filter/modules/benchmarking/types';
import { hasMeasureValue } from 'pages/Benchmarking/performance/helpers/hasMeasureValue';

export const toSum = <T>(series: T[], map: (entry: T) => number | undefined): number =>
  series.map(entry => map(entry) ?? 0).reduce((sum, val) => sum + val, 0);

export const getValues = (data: DataResult, benchmark: string, measure: Measure) => ({
  tenantValue: measure.getValue(data.values),
  tenantCompareValue: measure.getValue(data.compareValues),
  benchmarkValue: measure.getValue(data.benchmarks?.[benchmark]?.values),
  benchmarkCompareValue: measure.getValue(data.benchmarks?.[benchmark]?.compareValues),
});

export const createPerformanceMetrics = (
  data: DataResult,
  set: string,
  benchmark: string,
  measure: Measure,
  temporalType: BenchmarkingTemporalType,
  intl: IntlShape
): Model => ({
  ...getValues(data, benchmark, measure),
  timeSeries: data.sets[set].map((entry: DataEntry) => ({
    label: getLabelForDatapoint(entry, intl),
    dateRange: temporalType === 'WEEKLY' ? entry.dateRanges?.timeYearWeek : entry.dateRanges?.timeYearMonth,
    ...getValues(entry, benchmark, measure),
  })),
  hasTenantData: data.sets[set].some(entry => hasMeasureValue({ entry, measure })),
  hasPeerData: data.sets[set].some(entry => hasMeasureValue({ entry, measure, benchmark })),
  hasTenantCompareData: data.sets[set].some(entry =>
    hasMeasureValue({ entry, measure, compare: true, requirePositive: true })
  ),
  hasPeerGrowthData: data.sets[set].some(
    entry =>
      hasMeasureValue({ entry, measure, benchmark }) &&
      hasMeasureValue({ entry, measure, benchmark, compare: true, requirePositive: true })
  ),
});
